import React from 'react';
import ReactMarkdown, { Components } from 'react-markdown';
import { cx } from 'linaria';
import gfm from 'remark-gfm';
import breaks from 'remark-breaks';
import { Typography } from 'fronton-react';
import { replaceChars } from 'utils/replace-chars';
import { oListItem, orderedList, root } from './review-content-formatter.styles';
import { BreakableSafeText } from './styles';

const DEFAULT_COMPONENTS: { [nodeType: string]: React.ElementType } = {
  p: ({ children }) => (
    <Typography size="body_long" variant="s">
      {children}
    </Typography>
  ),
  a: ({ children }) => <BreakableSafeText>{children}</BreakableSafeText>,
  link: ({ children }) => <BreakableSafeText>{children}</BreakableSafeText>,
  ol: ({ children }) => <ol className={orderedList}>{children}</ol>,
  li: ({ children }) => (
    <Typography size="body_long" variant="m" as="li" className={oListItem}>
      {children}
    </Typography>
  ),
  br: () => ' ',
};

export type ReviewContentFormatterProps = {
  children: string;
  components?: Components;
} & React.HTMLAttributes<HTMLElement>;

export const ReviewContentFormatter: React.FC<ReviewContentFormatterProps> = ({
  components = DEFAULT_COMPONENTS,
  children,
  className = '',
  ...htmlProps
}) => {
  const text = replaceChars(children);

  return (
    <div className={cx(root, className)} {...htmlProps}>
      <ReactMarkdown components={components} remarkPlugins={[gfm, breaks]}>
        {text}
      </ReactMarkdown>
    </div>
  );
};
